import React from 'react';
import PropTypes from 'prop-types';
import { findLast, forEach, without, each, find } from 'lodash';
import { DndWrapperModel } from './models/DndWrapperModel';
import { getFirstRelativeParent } from '../text-helpers';

var containerId = 0;

var CONTAINER = 'container',
  LIST = 'list';

/**
 * Drag and Drop Base context. Manage all children dnd communications
 */
var DndContext = React.createClass({

  statics: {
    TYPE_CONTAINER: CONTAINER,
    TYPE_LIST: LIST
  },

  dndContainers: {},

  dndWrappers: [],

  childContextTypes: {
    onDndItemStartDrag: PropTypes.func.isRequired,
    registerDndContainer: PropTypes.func.isRequired,
    unregisterDndContainer: PropTypes.func.isRequired,
    registerDndWrapper: PropTypes.func.isRequired,
    unregisterDndWrapper: PropTypes.func.isRequired,
    isDragging: PropTypes.func.isRequired,
  },

  getChildContext() {
    var self = this;
    return {
      onDndItemStartDrag: (item, eventCoordinates, itemProps, dragItemCallback, draggableElement) => {
        each(this.dndWrappers, wrapper => wrapper.pinElementHeight());
        this.setState({
          isDragEvent: true,
          draggableElement,
          dragItemProps: itemProps,
          dragItemCallback: dragItemCallback,
          deltaX: eventCoordinates.deltaX,
          deltaY: eventCoordinates.deltaY,
          clientX: eventCoordinates.clientX,
          clientY: eventCoordinates.clientY,
          originalRelativeParentTop: eventCoordinates.originalRelativeParentTop,
          updateContextView: true,
          pageOffset: window.pageYOffset
        });

      },

      registerDndContainer: (container) => {
        containerId++;
        self.dndContainers[containerId] = container;
        self.dndContainers[containerId].id = containerId;
        return containerId;
      },

      unregisterDndContainer: function (id) {
        delete self.dndContainers[id];
      },

      registerDndWrapper: (wrapperElement) => { self.dndWrappers.push(new DndWrapperModel(wrapperElement)); },
      unregisterDndWrapper: (wrapperElement) => {
        const wrapper = find(self.dndWrappers, wrapper => wrapper.element === wrapperElement);
        if (wrapper) {
          wrapper.dispose();
          self.dndWrappers = without(self.dndWrappers, wrapper);
        }
      },

      isDragging() {
        return self.state.isDragEvent;
      }
    };
  },

  shouldComponentUpdate(nextProps, nextState){
    if (!nextState.updateContextView && nextProps.shouldUpdateFn) {
      return nextProps.shouldUpdateFn(this.props, nextProps);
    }
    return nextState.updateContextView;
  },

  componentDidMount(){
    window.addEventListener('scroll', this._onWindowScroll);
  },

  componentWillUnmount(){
    window.removeEventListener('scroll', this._onWindowScroll);
  },

  getInitialState(){
    return {
      updateContextView: true,
      isDragEvent: false,
      dragItemCallback: null,
      dragItemProps: {},
      clientX: 0,
      clientY: 0,
      deltaX: 0,
      deltaY: 0,
      pageOffset: window.pageYOffset
    };
  },

  render(){
    var props = {};

    if (this.state.isDragEvent) {
      props.onMouseMove = this.mouseMoveEventHandler;
      props.onMouseUp = this.mouseUpEventHandler;
      props.onTouchMove = this.touchMoveEventHandler;
      props.onTouchEnd = this.mouseUpEventHandler;
      props.style = this._getContextStyle();
    }

    return (<div {...props} className={this.props.className}>
      {this.props.children}
    </div>)
  },

  getDragCopyItemStyle(updatedDeltaY){
    const relativeParent = getFirstRelativeParent(this.state.draggableElement);
    const wrapper = find(this.dndWrappers, w => w.element === relativeParent);
    const wrapperScroll = wrapper ? wrapper.scrollTop : 0;

    const top = this.state.clientY - ((updatedDeltaY || this.state.deltaY) - wrapperScroll),
      left = this.state.clientX - this.state.deltaX;

    return {
      position: 'absolute',
      top: top + 'px',
      left: left + 'px',
      zIndex: 999
    }
  },

  touchMoveEventHandler(event){
    var touches = event.targetTouches;
    if (touches.length != 1) return;
    event.preventDefault();
    this.mouseMoveEventHandler(touches[0]);
  },

  mouseMoveEventHandler(event){
    var self = this;

    this.state.dragItemCallback({
      isDragging: true,
      style: self.getDragCopyItemStyle()
    });

    this.setState({
      clientX: event.clientX,
      clientY: event.clientY,
      updateContextView: false
    });

    this._dropContainerOverHandler(event);
    this._processDndWrappers();
  },

  mouseUpEventHandler(event){
    this.state.dragItemCallback({
      isDragging: false,
      style: {}
    });

    this._triggerMouseOutEvents(null, true);
    this.lastOverData = null;

    each(this.dndWrappers, wrapper => wrapper.unpinElementHeight());
    this.setState({
      isDragEvent: false,
      originalRelativeParentTop: null,
      draggableElement: null,
      dragItemProps: {},
      dragItemCallback: false,
      updateContextView: true
    });
  },

  _onWindowScroll(e){
    if (this.state.isDragEvent) {
      var self = this;

      this.setState({deltaY: self.state.deltaY + (self.state.pageOffset - window.pageYOffset)});

      var evt = {
        clientX: self.state.clientX,
        clientY: self.state.clientY
      };

      this.mouseMoveEventHandler(evt);
    }
  },

  _dropContainerOverHandler(event){
    if (find(this.dndWrappers, wrapper => wrapper.isBeingScrolled)) {
      return;
    }

    var self = this,
      {dndItemType} = this.state.dragItemProps;

    var container = findLast(this.dndContainers,
      (container) => {
        return self._findDndContainerCallback(container, dndItemType, event);
      });

    this._triggerMouseOutEvents(container);

    const draggableElement = event.target;
    const targetElement = container;

    if (draggableElement && targetElement) {
      this.lastOverData = { draggableElement, targetElement };
    }

    if (container && !container.isItemInContainer) {
      container.isItemInContainer = true;
      container.onMouseIn(dndItemType, self.state.dragItemProps.dndDropData);
    } else if (container && container.isItemInContainer && container.type === LIST) {
      container.onMouseOver(dndItemType, event, self.state.dragItemProps.dndDropData, this._createMouseOverContainerData(event, container));
    }
  },

  _processDndWrappers() {
    const { draggableElement } = this.state;
    if (!draggableElement) {
      return;
    }

    const draggableRect = draggableElement.getBoundingClientRect();
    const self = this;

    each(this.dndWrappers, wrapper => {
      if (wrapper.isElementCrossingUpperWrapperBoundary(draggableRect)) {
        window.requestAnimationFrame(() => {
          wrapper.scrollToTop(draggableRect.height);
          self._afterWrapperScroll();
        });
      }

      if (!wrapper.hasReachedPinnedHeight && wrapper.isElementCrossingLowerWrapperBoundary(draggableRect)) {
        window.requestAnimationFrame(() => {
          wrapper.scrollToBottom(draggableRect.height);
          self._afterWrapperScroll();
        });
      }

    });
  },

  _afterWrapperScroll() {
    const relativeParent = getFirstRelativeParent(this.state.draggableElement);

    // check if relatively positioned parent has moved away from the original position as a result of scrolling and update deltaY for proper coords calculation
    let updatedDeltaY;
    if (this.state.originalRelativeParentTop !== relativeParent.getBoundingClientRect().top) {
      updatedDeltaY = this.state.deltaY - this.state.originalRelativeParentTop;
      updatedDeltaY += relativeParent.getBoundingClientRect().top;
    }

    // rerender draggable element
    this.state.dragItemCallback({
      isDragging: true,
      style: this.getDragCopyItemStyle(updatedDeltaY)
    });

    if (this.state.isDragEvent) {
      this._processDndWrappers();
    }

    if (updatedDeltaY) {
      this.setState({ deltaY: updatedDeltaY, originalRelativeParentTop: relativeParent.getBoundingClientRect().top });
    }
  },

  _triggerMouseOutEvents: function (container, isDropEvent) {
    var self = this,
      {dndItemType} = this.state.dragItemProps;
    forEach(this.dndContainers, (item) => {
      if (!container || container.id != item.id) {
        if (item.isItemInContainer) {
          item.onMouseOut(dndItemType);
          if (isDropEvent) {
            item.onDrop(dndItemType, self.state.dragItemProps.dndDropData);
            isDropEvent = false;
          }
          item.isItemInContainer = false;
        }

        if (isDropEvent && this.lastOverData && this.lastOverData.targetElement === item) {
          item.onDrop(dndItemType, self.state.dragItemProps.dndDropData);
          this.lastOverData = null;
        }
      }
    });
  },

  _findDndContainerCallback(container, dndItemType, event){
    if (container.types.indexOf(dndItemType) < 0) {
      return false;
    }

    var clientRect = container.element.getBoundingClientRect();

    return ( event.clientX > clientRect.left
    && event.clientX < clientRect.right
    && event.clientY > clientRect.top
    && event.clientY < clientRect.bottom);
  },

  _createMouseOverContainerData(event, container) {
    const containerRect = container.element.getBoundingClientRect();
    const mousePositionInContainer = event.clientY - containerRect.top;
    const mouseToContainerOffset = mousePositionInContainer / containerRect.height;
    return {
      get isMouseInUpperContainerHalf() { return this.mouseToContainerOffset <= 0.5; },
      get isMouseInLowerContainerHalf() { return this.mouseToContainerOffset > 0.5; },
      mouseToContainerOffset
    };
  },

  _getContextStyle(){
    return {
      'WebkitTouchCallout': 'none',
      'WebkitUserSelect': 'none',
      'KhtmlUserSelect': 'none',
      'MozUserSelect': 'none',
      'MsUserSelect': 'none',
      'UserSelect': 'none'
    };
  }
});

module.exports = DndContext;
